<!-- 预览图中的按钮 -->
<template>
  <div class="preview-btn" :style="btnSize">
    <img :src="btnUrl" alt="" />
    <div class="btn-text" :style="btnTextStyle">{{ btnText }}</div>
    <div class="disabled-box" v-if="isDisabled"></div>
    <img
      v-if="isShowDynamicIcon"
      class="bargain-btn-icon"
      :style="btnSize"
      :src="dynamicUrl"
      alt=""
    />
  </div>
</template>
<script>
export default {
  props: {
    btnUrl: {
      type: String,
      default: "",
    },
    btnSize: {
      type: Object,
      default: () => ({
        width: "100px",
        height: "40px",
      }),
    },
    btnText: {
      type: String,
      default: "",
    },
    btnTextStyle: {
      type: Object,
      default: () => ({
        fontSize: "14px",
        color: "#fff",
      }),
    },
    dynamicUrl: {
      type: String,
      default:
        "https://cdn-image.yucrm.cn//hd/images/13315956_1909f13269454e1cad295156ffce6538.png",
    },
    isShowDynamicIcon: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.preview-btn {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // object-fit: cover;
  }
  .btn-text {
    text-align: center;
    z-index: 1;
  }
  .disabled-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.35);
  }
  .bargain-btn-icon {
    position: absolute;
    left: 0;
    bottom: 0;
    animation: identifier 2s infinite;
    border-radius: 19px 19px 19px 19px;
  }
  @keyframes identifier {
    0% {
      transform: translateX(-80%);
    }
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
